<template>
  <client-only>
    <div pa-0 id="cv-wizard">
      <v-row class="cv-wizard-inner pt-7">
        <v-col class="cv-wizard-header text-center" col="12">
          <h1 class="display-m-40">{{ header }}</h1>
          <p v-if="isUserLogged" class="display-36 mb-0">{{ subHeader }}</p>
        </v-col>

        <v-col>
          <v-stepper light v-model="model">
            <v-stepper-header>
              <v-stepper-step
                v-for="(step) in getStepsperStatus"
                :key="`${step.StepNumber}-step-header`"
                class="py-0 px-1 mt-3"
                :class="[
                  `step-btn step-btn-num${step.StepNumber}`,
                  step.IsAvailable ? 'stepper-available' : '',
                ]"
                :step="step.StepNumber"
                :complete="model > step.StepNumber"
                :editable="step.IsAvailable"
                @click="
                  ;[step.IsAvailable ? goToRoute(step.StepNumber) : false]
                "
              >
                <v-row class="pa-0 step">
                  <v-col class="pa-0">
                    <v-icon class="step-icon" :class="icons[step.StepNumber]" />
                  </v-col>
                  <v-col
                    class="pa-0 step-name"
                    v-html="`${step.KeyValue.Value}`"
                  ></v-col>
                </v-row>
              </v-stepper-step>
              <hr class="steppers-divider" color="primary" />
            </v-stepper-header>

            <v-stepper-items class="px-2">
              <v-stepper-content step="1" class="px-0" :id="`step-card${1}`">
                <CvWizardStep1 :step-content="getCVWStepContent(1)" />
              </v-stepper-content>
              <v-stepper-content step="2" class="px-0" :id="`step-card${2}`">
                <CvWizardStep2 :step-content="getCVWStepContent(2)" />
              </v-stepper-content>
              <v-stepper-content step="3" class="px-0" :id="`step-card${3}`">
                <CvWizardStep3 :step-content="getCVWStepContent(3)" />
              </v-stepper-content>
              <v-stepper-content step="4" class="px-0" :id="`step-card${4}`">
                <CvWizardStep4 :step-content="getCVWStepContent(4)" />
              </v-stepper-content>
              <v-stepper-content step="5" class="px-0" :id="`step-card${5}`">
                <CvWizardStep5 :step-content="getCVWStepContent(5)" />
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-col>
      </v-row>
    </div>
  </client-only>
</template>

<script>
import CvWizardBase from './base/CvWizardBase.vue'

export default {
  extends: CvWizardBase,
  props: {},
  data() {
    return {
      icons: {
        1: 'icon-identification',
        2: 'icon-education',
        3: 'icon-employee-1',
        4: 'icon-employee',
        5: 'icon-pdf',
      },
    }
  },
  created() {},
  methods: {
    incrementItem(val) {
      let temp = parseInt(val)
      return temp + 1
    },
    goToRoute(number) {
      let page = `/קורות-חיים/${number}/`
      this.$router.push(page)
    },
  },
}
</script>

<style lang="scss" scoped>
#cv-wizard {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
#cv-wizard .cv-wizard-header {
  background-color: #f6f7f9;
}
#cv-wizard .cv-wizard-inner {
  flex-direction: column;
}
#cv-wizard .v-stepper {
  box-shadow: none;
  max-width: 850px;
  margin: 0 auto;
}
#cv-wizard .v-stepper:not(.v-stepper--vertical) .v-stepper__step__step {
  display: none;
}
#cv-wizard .v-stepper__header {
  position: relative;
  height: auto;
  box-shadow: none;
  align-items: start;
  flex-wrap: nowrap;
  justify-content: space-between;
}
#cv-wizard .step {
  position: relative;
  z-index: 5;
  justify-content: center;
  flex-direction: column;
  text-align: center;
}

#cv-wizard .step .step-icon {
  font-size: 7vw;
  display: inline-flex;
  border: 1px solid gray;
  border-radius: 100px;
  padding: 8px 9px;
  background-color: #fff;
}
#cv-wizard .step .step-name {
  max-width: 70px;
}

// <steppers display status display>

// - complete
#cv-wizard
  .v-stepper__step--editable.v-stepper__step--complete
  .step
  .step-icon {
  color: #000;
  border: 1px solid #ff7100;
}
#cv-wizard
  .v-stepper__step--editable.v-stepper__step--complete
  .step
  .step-name {
  color: #000;
}

// -active
#cv-wizard .v-stepper__step--active.v-stepper__step--editable .step .step-icon {
  color: #000;
  border: 1px solid #000;
}
#cv-wizard .v-stepper__step--active.v-stepper__step--editable .step .step-name {
  color: #000;
}

// -inactive editible
#cv-wizard
  .v-stepper__step--inactive.v-stepper__step--editable
  .step
  .step-icon {
  color: #000;
  border: 1px solid #000;
}
#cv-wizard
  .v-stepper__step--inactive.v-stepper__step--editable
  .step
  .step-name {
  color: #000;
}

// </steppers display status display>

#cv-wizard .v-stepper:not(.v-stepper--vertical) .v-stepper__label {
  display: block !important;
  font-size: 12px;
}
#cv-wizard .step-card {
  min-height: fit-content;
}
#cv-wizard .step-card .col-sm-6 {
  padding: 5px 12px;
}
.steppers-divider {
  position: absolute;
  z-index: 1;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 80%;
  top: 35%;
  transform: translateY(-38%);
  border-color: $primary;
}

@media screen and (min-width: 600px) {
  .steppers-divider {
    width: 85%;
  }

  #cv-wizard .step .step-icon {
    font-size: 2vw;
  }
  
  #cv-wizard .v-stepper:not(.v-stepper--vertical) .v-stepper__label {
    display: block !important;
    font-size: 16px;
  }
}
</style>
